import { ROTA_APIS } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

export interface IRotaSlotRemovalCreatePayload {
  staff_id: string;
  clinic_id: string;
  date: string;
  sub_service_ids: string[];
  start_time: string;
  end_time: string;
  confirmed: boolean;
}

export interface IRotaSlotRemovalCreateResponse {
  status: boolean;
  message: string | null;
  data: any;
}

export const useRotaSlotRemovalCreateAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [loading, setLoading] = useState<boolean>(false);

  const execute = useCallback(
    async (payload: IRotaSlotRemovalCreatePayload): Promise<IRotaSlotRemovalCreateResponse> => {
      setLoading(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<IRotaSlotRemovalCreateResponse> = await axios.post(
          ROTA_APIS?.ROTA_SLOT_REMOVALS?.baseURL ?? "",
          payload,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (res.data.status === true) {
          return res.data;
        } else {
          toast.error(res.data.message || "Failed to remove slot");
          return res.data;
        }
      } catch (error: any) {
        if (axios.isAxiosError(error)) {
          sendCurl?.(error.config?.["curlCommand"]);
          toast.error("Error: " + (error.response?.data?.message || error.message));
        } else {
          toast.error("Server Error: " + error.message);
        }
        return { status: false, message: error.response?.data?.message, data: null };
      } finally {
        setLoading(false);
      }
    },
    [configuration, sendCurl]
  );

  return { execute, loading };
};
